import { useEffect, useState } from "react";
import type { PasswordCheckResult } from "../../shared/api-types";
import { apiJson } from "./api";

/**
 * Live-Prüfung eines Passwortfelds gegen die Server-Richtlinie (POST
 * /api/password-check, entprellt). Nur Hinweis: verbindlich prüft der Server
 * beim Speichern — deshalb schlucken wir Fehler hier still.
 */
export function usePasswordCheck(
  password: string,
  info: { email?: string; name?: string } = {},
): PasswordCheckResult | null {
  const [result, setResult] = useState<PasswordCheckResult | null>(null);
  const { email, name } = info;

  useEffect(() => {
    if (!password) {
      setResult(null);
      return;
    }
    const ctrl = new AbortController();
    const timer = setTimeout(() => {
      apiJson<PasswordCheckResult>("/api/password-check", {
        method: "POST",
        json: { password, email, name },
        signal: ctrl.signal,
      })
        .then(setResult)
        .catch(() => {
          /* Anzeige ist optional */
        });
    }, 300);
    return () => {
      clearTimeout(timer);
      ctrl.abort();
    };
  }, [password, email, name]);

  return result;
}
